export default __webpack_public_path__ + "static/media/parachute.314991e2.png";